//
// Module for the Participant Communication's Portal Messages view
//
rs.module("content/participant/account/communications/portalrequests",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, backendUrls, portalRequestsGridLrsApi) {

            // Unpack Js Selectors
            var requestDetail = $.js(jsSelectors.requestDetail);

            // Handle the message thread grid change event
            portalRequestsGridLrsApi.selectionChanged(function (values, rows) {         

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // Clear event banner
                    eventBanner.removeAllMessages();

                    $.get(backendUrls.getPortalRequestDetail,
                        {
                            portalRequestKey: values[0]
                        })
                        .done(function (result) {
                            requestDetail.html(result);
                        });
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);